var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-header-wrapper',[_c('a-card',{attrs:{"bordered":false}},[_c('wire-transfer-configuration')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }